import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatrixRow } from '../models/sla.models';
import { PctChip } from './pct-chip';

/**
 * The "% Met by X and Priority" matrices: every cell is a color-banded
 * percentage; blank cells mean no tickets for that combination.
 * `totalOverall` reproduces the sheet's BU-matrix Total row, where only the
 * Overall column is populated.
 */
@Component({
  selector: 'app-matrix-table',
  imports: [PctChip],
  template: `
    <div class="table-scroll">
      <table class="sla-table matrix">
        <thead>
          <tr>
            <th class="row-label" scope="col">{{ rowHeader() }}</th>
            @for (c of cols; track c.short) {
              <th scope="col" [title]="c.full">{{ c.short }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (r of rows(); track r.label) {
            <tr>
              <td class="row-label">{{ r.label }}</td>
              @for (p of r.pcts; track $index) {
                <td class="pct"><app-pct-chip [pct]="p" /></td>
              }
            </tr>
          }
        </tbody>
        @if (totalOverall() !== undefined) {
          <tfoot>
            <tr>
              <td class="row-label">Total</td>
              @for (c of cols.slice(0, 5); track c.short) {
                <td class="pct"><span class="pct-empty">—</span></td>
              }
              <td class="pct"><app-pct-chip [pct]="totalOverall() ?? null" /></td>
            </tr>
          </tfoot>
        }
      </table>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatrixTable {
  readonly rowHeader = input.required<string>();
  readonly rows = input.required<MatrixRow[]>();
  /** Leave unset to omit the Total row. */
  readonly totalOverall = input<number | null | undefined>(undefined);

  protected readonly cols = [
    { short: 'P1', full: 'Priority 1' },
    { short: 'P2', full: 'Priority 2' },
    { short: 'P3', full: 'Priority 3' },
    { short: 'P4', full: 'Priority 4' },
    { short: 'P5', full: 'Priority 5' },
    { short: 'Overall', full: 'Overall' },
  ];
}
